import '../../styles/templates/pages/page.order-lookup.scss';
import { prependLocaleToPath } from '../utils/localization';
import { generateToken } from '../utils/token-generator';

const OrderLookupLookup = function (event: Event) {
  event.preventDefault();

  const form = event.target as HTMLFormElement;
  form.classList.remove('error');

  const formData = new FormData(form);
  const order = formData.get('order'); // can be either order number or order confirmation
  const email = formData.get('email');

  const url = `${form.action}${order}/${email}`;
  fetch(url)
    .then((res: Response) => {
      if (!res.ok) showError();
      else
        return res
          .json()
          .then((response) => handleResponse(response, order?.toString(), email?.toString().toLowerCase()));
    })
    .catch(handleError);
};

const useRealtimeTracking = window.getSiteSettings?.().orderTrackingEnabled ?? false;

const errorContainer = document.querySelector('.WizOrderForm .submit-area .error');
const wizOrderForm = document.querySelector('.WizOrderForm form');

const handleResponse = async function (response: { order_status_url?: string }, order?: string, email?: string) {
  // If flag on and we have order & email, redirect to new  order status page
  if (useRealtimeTracking && order && email) {
    try {
      const orderReference = order.replace('#', '');
      const token = await generateToken(orderReference, email);
      const url = `/pages/order-status?order_reference=${orderReference}&token=${token}`;
      return (window.location.href = prependLocaleToPath(url));
    } catch (error) {
      console.log('Token generation failed, falling back to legacy flow:', error);
      // Fall through to legacy flow below
    }
  }

  // Flag off then existing flow fallback
  if (response?.order_status_url) return (window.location.href = response?.order_status_url);

  showError();
};

const handleError = function () {
  if (!errorContainer) return;
  errorContainer.innerHTML =
    "Sorry, we're having trouble contacting the server. Please try again later. Still having trouble? <a href='/pages/contact-us'>Contact us</a>.";
  wizOrderForm?.classList.add('error');
};

const showError = function () {
  if (!errorContainer) return;
  errorContainer.innerHTML =
    "<p>Order not found</p><span class='small-p'>Invalid combination. Please try a different email address or order confirmation #.</span>";
  wizOrderForm?.classList.add('error');
};

wizOrderForm?.addEventListener('submit', OrderLookupLookup);
